import useNodeName from 'pages/Flow/components/Canvas/utils/useNodeName';

const ObjectNameFromNode = ({ node }) => {
  const [name] = useNodeName(node);
  return name;
};

export default ObjectNameFromNode;
